import { render, staticRenderFns } from "./pdfBox.vue?vue&type=template&id=49159210"
import script from "./pdfBox.vue?vue&type=script&lang=js"
export * from "./pdfBox.vue?vue&type=script&lang=js"
import style0 from "./pdfBox.vue?vue&type=style&index=0&id=49159210&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports